import { AutoLoanCriteria } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

export const referenceFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.12,
    field: 'reference',
    sortable: true,
    align: 'left',
    disableOnRowClick: true,
    headerName: <Text tId={'REFERENCE'} />,
    renderCell: (rowData: { row: AutoLoanCriteria }) => {
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            lineHeight: 1.43,
            width: '100%',
          }}
        >
          <div className="shorted-cell simple-select overflow-text-ellipsis">{rowData.row.reference || '-'}</div>
        </div>
      );
    },
  };
};
